import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay, tap } from 'rxjs';
import { ConfigService } from './config.service';
import { AgencyCardView, ApiAgency } from '../models/agency-api.models';
import { ApiConfigService } from './api-config.service';
import { CharterColorService } from './charter-color.service';

@Injectable({ providedIn: 'root' })
export class AgencyApiService {
  private cachedList$: Observable<ApiAgency[]> | null = null;

  constructor(
    private readonly http: HttpClient,
    private readonly apiConfig: ApiConfigService,
    private readonly charterColor: CharterColorService,
    private readonly configService: ConfigService,
  ) {}

  /** GET /api-design{suffixe}/agency/findall */
  list(forceRefresh = false): Observable<ApiAgency[]> {
    const url = this.apiConfig.agencyListUrl;

    if (!this.cachedList$ || forceRefresh) {
      this.cachedList$ = this.http.get<ApiAgency[]>(url).pipe(
        tap((response) => {
          if (this.configService.enableApiLogs) {
            console.log('[AgencyApi] list', url, response);
          }
        }),
        shareReplay(1)
      );
    }

    return this.cachedList$;
  }

  listCards(forceRefresh = false): Observable<AgencyCardView[]> {
    return this.list(forceRefresh).pipe(
      map((items) => items.map((item, index) => this.toCardView(item, index)))
    );
  }

  clearCache(): void {
    this.cachedList$ = null;
  }

  toCardView(item: ApiAgency, index = 0): AgencyCardView {
    const city = this.extractCity(item.name, item.address);
    return {
      id: item.id,
      name: item.name,
      city,
      address: item.address,
      latitude: item.latitude,
      longitude: item.longitude,
      mapUrl: `https://www.google.com/maps?q=${item.latitude},${item.longitude}`,
      tag: city,
      accentColor: this.charterColor.getAccentPalette()[index % this.charterColor.getAccentPalette().length],
    };
  }

  private extractCity(name: string, address: string): string {
    const fromName = name.split(/[–—-]/)[0]?.trim();
    if (fromName) {
      return fromName;
    }

    const parts = address.split(',').map((p) => p.trim()).filter(Boolean);
    return parts[parts.length - 2] || parts[0] || 'Cameroun';
  }
}
